import React from 'react';
import styles from './Loader.module.css';

interface LoaderProps {
  text?: string;
  size?: 'sm' | 'default' | 'lg';
  className?: string;
}

const Loader: React.FC<LoaderProps> = ({
  text = 'Loading...',
  size = 'default',
  className = '',
}) => {
  const getSpinnerClass = () => {
    switch (size) {
      case 'lg':
        return `${styles.spinner} ${styles.spinnerLg}`;
      case 'sm':
        return `${styles.spinner} ${styles.spinnerSm}`;
      default:
        return styles.spinner;
    }
  };

  const getTextClass = () => {
    switch (size) {
      case 'lg':
        return `${styles.loadingText} ${styles.loadingTextLg}`;
      case 'sm':
        return `${styles.loadingText} ${styles.loadingTextSm}`;
      default:
        return styles.loadingText;
    }
  };

  return (
    <div className={styles.container}>
      <div className={`${styles.loadingContainer} ${className}`.trim()}>
        <div className={getSpinnerClass()} />
        {text && (
          <p className={getTextClass()}>
            {text}
          </p>
        )}
      </div>
    </div>
  );
};

export default Loader;